import React from "react";

import APIComponent from "../../components/API";
import core from "../../vendors/core-api";
import { useParams, Redirect, Link } from "react-router-dom";
import { useSelector } from "react-redux";
// import helpertexts from "../../helpertexts";
import Breadcrumbs from "../../components/Breadcrumbs";
import { LayoutSplashScreen } from "../../../_metronic/layout";
import TitleHelmet from "../../partials/TitleHelmet";
import {
  Block,
  HeaderTextWithActions,
  LoadingDiv,
  Label,
} from "../../components/Base";
import { Row, Col, Tab, Nav, Card } from "react-bootstrap";
import moment from "moment";
import { generatePickupPhLink } from "../../helpers";
import Datatable from "react-data-table-component";
import PacmanWrapper from "../../components/dashboard/PacmanWrapper";

const MENUS = {
  main: "main",
  stores: "stores",
};

function FieldsRow({ fields }) {
  return (
    <Row>
      {fields.map((field, index) => {
        const { value = "N/A" } = field;
        return (
          <Col key={index}>
            <Block
              content={
                <>
                  <Label
                    text={
                      <>
                        <span className="va-middle text-capitalize">
                          {field.name}
                        </span>
                      </>
                    }
                  />
                  <div>{value}</div>
                </>
              }
            />
          </Col>
        );
      })}
    </Row>
  );
}

function Table({
  data,
  group_id = "",
  brand_id = "",
  progressPending = false,
}) {
  const [searchText, setSearchText] = React.useState("");
  const filteredItems =
    searchText !== ""
      ? data.filter((item) => {
          return (
            item.name.toLowerCase().indexOf(searchText.toLowerCase()) !== -1
          );
        })
      : data;

  return (
    <>
      <Datatable
        columns={[
          {
            name: "Store Name",
            selector: (row) => {
              return row.name;
            },
            format: (row) => {
              return (
                <Link
                  to={`/admin/groups/${group_id}/brands/${brand_id}/stores/${row._id}`}
                  className="font-weight-bolder text-primary"
                >
                  {row.name}
                </Link>
              );
            },
            sortable: true,
            style: "font-weight-bold",
          },
          {
            name: "Date Created",
            selector: (row) => {
              return moment(row.date_created).format("MMM D, YYYY hh:mm A");
            },
          },
        ]}
        data={filteredItems}
        pagination
        noHeader
        highlightOnHover
        subHeader
        subHeaderWrap={false}
        subHeaderComponent={
          <>
            <Row>
              <Col>
                <div className="input-group">
                  <div className="input-group-prepend">
                    <span className="input-group-text">
                      <i className="flaticon-search"></i>
                    </span>
                  </div>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Search"
                    value={searchText}
                    onChange={(e) => {
                      setSearchText(e.target.value);
                    }}
                  />
                </div>
              </Col>
            </Row>
          </>
        }
        progressPending={progressPending}
      />
    </>
  );
}

export default function Page() {
  const { brand_id = "", group_id = "" } = useParams(),
    { user } = useSelector((state) => state.auth);
  return <MainComponent id={brand_id} group_id={group_id} user={user} />;
}

class MainComponent extends APIComponent {
  constructor(props) {
    super(props);

    this.state = {
      showSplashScreen: false,
      redirectTo: "",
      title: "Brand",
      group_name: "",
      brand_name: "",
    };

    this.api = core("pu").get();
    this.data_url = "/brand/" + this.props.id;

    this.setActiveMenu = this.setActiveMenu.bind(this);
  }

  handleOnDataFetched = () => {
    const { data = {} } = this.state;
    this.setState({
      group_name: data.client.name,
      brand_name: data.name,
      title: data.name,
    });
  };

  setActiveMenu = (activeMenuKey) => {
    this.setState({ activeMenuKey });
  };

  render() {
    const {
        group_name = "",
        brand_name = "",
        title = "",
        data_status = "",
        data = {},
      } = this.state,
      isLoading = data_status !== "fetched";

    return (
      <>
        <TitleHelmet title={this.state.title} />

        {this.state.showSplashScreen ? <LayoutSplashScreen /> : <></>}

        {this.state.redirectTo !== "" ? (
          <Redirect to={this.state.redirectTo} />
        ) : (
          <></>
        )}

        {isLoading ? (
          <PacmanWrapper removeBackgroundColor />
        ) : (
          <>
            <HeaderTextWithActions
              title={title}
              className="mb-8"
              breadcrumbs={
                <Breadcrumbs>
                  <Breadcrumbs.Item text="Groups" link={`/admin/groups`} />
                  <Breadcrumbs.Item
                    text={group_name}
                    link={`/admin/groups/${this.props.group_id}`}
                  />
                  <Breadcrumbs.Item
                    text={"Brands"}
                    link={`/admin/groups/${this.props.group_id}/brands`}
                  />
                  <Breadcrumbs.Item text={brand_name} link={null} />
                </Breadcrumbs>
              }
            />

            <Tab.Container
              id="left-tabs-example"
              defaultActiveKey={MENUS.main}
              activeKey={this.state.activeMenuKey}
            >
              <Row>
                <Col sm={3}>
                  <Card>
                    <Card.Body>
                      <Nav variant="pills" className="flex-column">
                        <Nav.Item>
                          <Nav.Link
                            eventKey={MENUS.main}
                            onClick={() => this.setActiveMenu(MENUS.main)}
                          >
                            Brand Information
                          </Nav.Link>
                        </Nav.Item>
                        <Nav.Item>
                          <Nav.Link
                            eventKey={MENUS.stores}
                            onClick={() => this.setActiveMenu(MENUS.stores)}
                          >
                            Stores
                          </Nav.Link>
                        </Nav.Item>
                      </Nav>
                    </Card.Body>
                  </Card>
                </Col>
                <Col sm={9}>
                  <Tab.Content>
                    <Tab.Pane eventKey={MENUS.main}>
                      <Card>
                        <Card.Body>
                          {[
                            [{ name: "brand name", value: data.name }],
                            [
                              {
                                name: "brand url",
                                value: (
                                  <a
                                    href={generatePickupPhLink(data.brand_url)}
                                  >
                                    {generatePickupPhLink(
                                      data.brand_url,
                                      false,
                                    )}
                                  </a>
                                ),
                              },
                            ],
                            [
                              {
                                name: "date created",
                                value: moment(data.date_created).format(
                                  "MMM D, YYYY hh:mm A",
                                ),
                              },
                            ],
                          ].map((fields) => {
                            return <FieldsRow fields={fields} />;
                          })}
                        </Card.Body>
                      </Card>
                    </Tab.Pane>
                    <Tab.Pane eventKey={MENUS.stores}>
                      <Card>
                        <Card.Body>
                          <Table
                            data={data.stores}
                            group_id={this.props.group_id}
                            brand_id={this.props.id}
                            progressPending={isLoading}
                          />
                        </Card.Body>
                      </Card>
                    </Tab.Pane>
                  </Tab.Content>
                </Col>
              </Row>
            </Tab.Container>
          </>
        )}
      </>
    );
  }
}
